import React from 'react';
import get from 'base-ui/dist/underline/get';
import { intl } from 'components/LocaleProvider';
import Icon from 'base-ui/dist/Icon';
import getConfig from 'next/config';
import messages from './DefaultHeader/messages';

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

function config(props) {
  const courses = get(props, 'courses', false);
  const services = get(props, 'services', false);
  const type = get(props, 'type', 'desktop');

  const availableItems = {
    dashboard: {
      id: 1,
      label: intl.formatMessage(messages.headerDashboardLabel),
      visibility: {
        roles: ['administrator', 'teacher', 'professional'],
      },
      url: publicRuntimeConfig.DASHBOARD_URL,
      routerStrategy: 'none',
      icon: <Icon prefix="fas" name="tachometer-alt" />,
    },
    office: {
      id: 2,
      url: intl.formatMessage(messages.headerOfficeUrl),
      label: intl.formatMessage(messages.headerOfficeLabel),
      routerStrategy: 'none',
      icon: <Icon prefix="fas" name="columns" />,
    },
    account: {
      id: 3,
      url: intl.formatMessage(messages.headerAccountUrl),
      label: intl.formatMessage(messages.headerAccountLabel),
      routerStrategy: 'none',
      icon: <Icon prefix="fas" name="cog" />,
    },
    enrollments: {
      id: 4,
      url: intl.formatMessage(messages.headerEnrollmentsUrl),
      label: intl.formatMessage(messages.enrollmentsLabel),
      routerStrategy: 'none',
      visibility: {
        roles: [courses ? '*' : 'none']
      },
      icon: <span><i className="fas fa-user-graduate"></i></span>
    },
    reservations: {
      id: 5,
      url: intl.formatMessage(messages.headerReservationsUrl),
      label: intl.formatMessage(messages.headerReservationsLabel),
      routerStrategy: 'next',
      visibility: {
        roles: [services ? '*' : 'none']
      },
      icon: <Icon prefix="far" name="calendar-check" />,
    },
    inbox: {
      id: 6,
      url: intl.formatMessage(messages.headerMessagesUrl),
      label: intl.formatMessage(messages.headerMessagesLabel),
      routerStrategy: 'none',
      icon: <Icon prefix="far" name="comments" />,
    },
    wishlist: {
      id: 7,
      url: intl.formatMessage(messages.wishlistUrl),
      label: intl.formatMessage(messages.headerWishlistLabel),
      routerStrategy: 'none',
      visibility: {
        roles: [courses ? '*' : 'none']
      },
      icon: <Icon prefix="far" name="heart" />,
    },
    bookmarks: {
      id: 8,
      url: intl.formatMessage(messages.bookmarksUrl),
      label: intl.formatMessage(messages.headerBookmarksLabel),
      routerStrategy: 'next',
      icon: <Icon prefix="far" name="bookmark" />,
    }
  };

  const desktopItems = [
    availableItems.dashboard,
    availableItems.office,
    availableItems.account,
    availableItems.enrollments,
    availableItems.reservations,
    availableItems.inbox,
    availableItems.wishlist,
    availableItems.bookmarks
  ];

  let desktop = desktopItems;

  if (!publicRuntimeConfig.react_courses_webapp) {
    desktop = desktop.filter((item) => item.url !== intl.formatMessage(messages.headerEnrollmentsUrl));
  }
  if (!publicRuntimeConfig.react_consultation_webapp) {
    desktop = desktop.filter((item) => item.url !== intl.formatMessage(messages.headerReservationsUrl));
  }

  const mobileItems = [
    availableItems.reservations,
    {
      id: 94,
      label: intl.formatMessage(messages.headerProfileLabel),
      children: [
        availableItems.dashboard,
        availableItems.office,
        availableItems.account,
        availableItems.inbox,
        availableItems.enrollments,
        availableItems.wishlist,
        availableItems.bookmarks
      ]
    }
  ];

  let mobile = mobileItems;

  if (!publicRuntimeConfig.react_courses_webapp) {
    mobile = mobile.filter((item) => item.url !== intl.formatMessage(messages.headerEnrollmentsUrl));
  }
  if (!publicRuntimeConfig.react_consultation_webapp) {
    mobile = mobile.filter((item) => item.url !== intl.formatMessage(messages.headerReservationsUrl));
  }

  const result = {
    meta: [],
    menu: {
      items: type === 'desktop' ? desktop : mobile,
    },
  };

  return result;
}

export default config;
